import { useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { Button, Input } from '@rb/ui'
import { setCurrentUser } from '../lib/auth'
import styles from './Auth.module.css'

export default function ConfirmEmail() {
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const token = params.get('token') ?? ''

  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (password !== confirm) {
      setError('Passwörter stimmen nicht überein')
      return
    }
    if (password.length < 8) {
      setError('Das Passwort muss mindestens 8 Zeichen lang sein')
      return
    }
    setError('')
    setLoading(true)
    try {
      const res = await fetch('/api/auth/verify-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      })
      const data = (await res.json()) as {
        token: string
        user: { id: string; email: string; name: string | null; role: 'client' | 'admin' | 'super_admin' }
        error?: string
      }
      if (!res.ok) {
        setError(data.error ?? 'Konto konnte nicht eingerichtet werden')
        return
      }
      setCurrentUser({ ...data.user, name: data.user.name ?? '', token: data.token })
      navigate('/dashboard')
    } catch {
      setError('Verbindungsfehler. Bitte erneut versuchen.')
    } finally {
      setLoading(false)
    }
  }

  if (!token) {
    return (
      <div className={styles.card}>
        <h1 className={styles.heading}>Ungültiger Link</h1>
        <p className={styles.error}>Dieser Bestätigungslink ist ungültig oder abgelaufen.</p>
        <div className={styles.footer}>
          <Link to="/projects/new" className={styles.link}>
            Neues Projekt anlegen
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.card}>
      <h1 className={styles.heading}>Konto einrichten</h1>
      <form onSubmit={handleSubmit} className={styles.form}>
        <Input
          type="password"
          label="Passwort"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="new-password"
          required
        />
        <Input
          type="password"
          label="Passwort bestätigen"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          autoComplete="new-password"
          required
        />
        {error && <p className={styles.error}>{error}</p>}
        <Button type="submit" disabled={loading} style={{ width: '100%' }}>
          {loading ? 'Wird eingerichtet…' : 'Konto einrichten'}
        </Button>
      </form>
    </div>
  )
}
